<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/faq" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Add FAQ</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="faqForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-8 form-div">
                <b-form-group>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Question is required.',
                    }"
                  >
                    <v-text-field
                      :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.question"
                      label="Question"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Answer is required.',
                    }"
                  >
                  <!-- <vue-editor
                      placeholder="Answer..."
                      :class="errors[0] ? 'error-outline' : ''"
                      v-model="form.answer"
                    ></vue-editor> -->
                    <ckeditor
                      v-model="form.answer"
                      :config="editorConfig"
                      :error-messages="errors[0]"
                    ></ckeditor>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group class="mt-5">
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Enabled' : 'Disabled'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn
                    class="submit-btn-fill-outline"
                    @click="goToBack"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="faq" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { VueEditor, Quill } from "vue2-editor";
import adminAPI from "@/api/admin";
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);

Vue.use(Notifications);
export default {
  name: "AddFaq",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.userId = localStorage.getItem("local_products_user_access_id");
    }
  },
  data() {
    return {
      formError: false,
      userId: null,
      formData: [],
      btnDisable: false,
      submitText: "Submit",
      status: true,
      form: {
        question: null,
        answer: null,
      },
      editorConfig: {language: 'de',scayt_sLang : 'de_DE'},
    };
  },
  components: {
    // VueEditor,
  },
  methods: {
    goToBack() {
      this.$router.push({ name: "faq" });
    },
    onSubmit() {
      this.$refs.faqForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.submitText = "Submitting...";
          let fd = new FormData();
          fd.append("question", this.form.question);
          fd.append("answer", this.form.answer);
          fd.append("status", this.status == true ? "1" : "0");
          setTimeout(() => {
            adminAPI
              .addFaq(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Submit"
                  this.btnDisable = false;
                  this.$notify({
                    group: "faq",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "faq" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Submit";

                  this.$notify({
                    group: "faq",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Submit";
                this.$notify({
                  group: "faq",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Submit";
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
